import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private logger: LoggerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: 2,
        delay: (error, retryCount) => {
          // Solo reintentar peticiones idempotentes (GET/HEAD): un POST/PUT/PATCH/DELETE
          const isIdempotent = request.method === 'GET' || request.method === 'HEAD';
          // Solo reintentar en caso de errores de red (0) o errores 5xx
          if (isIdempotent && (error.status === 0 || (error.status >= 500 && error.status < 600))) {
            // Backoff exponencial: 1s, 2s
            return timer(Math.pow(2, retryCount - 1) * 1000);
          }
          // No reintentar para otros errores
          throw error;
        },
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          // Error del lado del cliente
          this.logger.error('Error del cliente:', error.error);
        } else {
          // Error del lado del servidor
          switch (error.status) {
            case 0:
              this.logger.error(
                'Error de red:',
                'No se pudo conectar con el servidor. Verifique su conexión a internet.'
              );
              break;
            case 400:
              this.logger.error('Error 400:', error.error);
              break;
            case 401:
              this.logger.warn('Error 401: Usuario no autorizado');
              // La lógica de redirección se maneja en BotGuard
              break;
            case 403:
              this.logger.error('Error 403:', error.error);
              break;
            case 404:
              this.logger.error('Error 404:', error.url);
              break;
            case 500:
              this.logger.error('Error 500:', error.error);
              break;
            case 503:
              this.logger.error('Error 503:', error.error);
              break;
            default:
              this.logger.error(`Error HTTP ${error.status}:`, error.error);
          }
        }

        // TODO(qol): mostrar el error al usuario vía MessageService (p-toast global ya existe
        // en app.component.html). Decisión jul-2026: NO activar todavía — requiere primero un
        // mecanismo de exclusión para los flujos que ya muestran su propio error (45 componentes
        // usan MessageService a mano) o se duplicarían toasts.
        // this.notificationService.showError(errorMessage);

        return throwError(() => error);
      })
    );
  }
}
